import React from 'react';
import ColorSplotch from '@components/ColorSplotch';
import { BadgeSharedWithMeIcon, BadgeStarredIcon } from '@components/Icons';
import styles from './GroupIdentifierIcon.module.scss';
import Group from '@models/Group';

export default function GroupIdentifierIcon({
  group,
  className = null,
}: {
  group: Partial<Group>;
  className?: string;
}) {
  let icon = null;

  if (group.slug === 'starred') {
    icon = <BadgeStarredIcon />;
  } else if (group.slug === 'shared-with-me') {
    icon = <BadgeSharedWithMeIcon />;
  } else {
    icon = <ColorSplotch className={styles.color} color={group.color} />;
  }

  return <span className={className}>{icon}</span>;
}
